import React from 'react'

function Footer() {
  return (
    <div class="pt-2 md:mt-4 md:p-8 wrapper bg-gradient-to-r from-pink-600 to bg-purple-700 text-center md:p-4 md:text-xl">
      <p className=" px-3 py-2 font-serif text-white font-semibold ">
      Thanks for visiting  </p>
      <p className=" p-1 text-white font-semibold ">
      &#169; 2022 - &nbsp;  Kothari Mobile Zone Chinyalisaur Uttarkashi </p>
    </div>
  )
}

export default Footer